<template>
  <div id="trending-container">
    <h2>
      <i class="fas fa-poll"></i>
      กองทุนยอดนิยม
    </h2>
    <list-item class="list"
      v-for="fund in getTrendingFundTopThreeList"
      data-action="open_fund"
      data-listname="home_trending"
      :data-fundname="fund.short_code"
      :key="fund.id"
      :name="fund.short_code"
      :date="fund.data_date"
      :period="'1 Day'"
      :price="fund.nav"
      :change="fund.return_1d"
      :action="navigateToFund"
        :query="{id:fund.id}"
    />
    <!-- <tabs class="list">
      <tab name="กองทุน" data-tab="home_trending_fund" :selected="true">
        <list-item
          v-for="fund in getTrendingFundTopThreeList"
          data-action="open_fund"
          data-listname="home_trending"
          :data-fundname="fund.short_code"
          :key="fund.id"
          :name="fund.short_code"
          :date="fund.data_date"
          :period="'1 Day'"
          :price="fund.nav"
          :change="fund.return_1d"
          :action="navigateToFund"
          :query="{id:fund.id}"
        ></list-item>
      </tab>
      <tab name="หุ้น" data-tab="home_trending_stock">
        <list-item
          v-for="stock in getTrendingStockTopThreeList"
          data-action="open_stock"
          data-listname="home_trending"
          :data-stockname="stock.security_name"
          :key="stock.security_id"
          :name="stock.security_name"
          :date="stock.data_date"
          :period="'1 Day'"
          :price="stock.close"
          :change="stock.return_1d"
          :action="navigateToStock"
          :query="{name: stock.security_name}"
        ></list-item>
      </tab>
    </tabs> -->

    <modal-slide-up
      v-if="showModal"
      :options="{modalSize: 'tall'}"
      @close-modal="closeModal"
      class="modal"
      :padding="false"
    >
      <div id="modal-header" slot="header">กองทุนยอดนิยม</div>
      <div class="modal-item-list" slot="body">
        <list-item
        v-for="(fund,index) in getTrendingFundList"
        data-action="open_fund"
        data-listname="trending_modal"
        :data-fundname="fund.short_code"
        :key="fund.id"
        :index="index + 1"
        :name="fund.short_code"
        :date="fund.data_date"
        :period="'1 Day'"
        :price="fund.nav"
        :change="fund.return_1d"
        :action="navigateToFund"
        :query="{id:fund.id}"
        />
      </div>
      <!-- <tabs class="modal-item-list" slot="body">
        <tab name="กองทุน" data-tab="home_trending_fund" :selected="true">
          <list-item
            v-for="(fund,index) in getTrendingFundList"
            data-action="open_fund"
            data-listname="trending_modal"
            :data-fundname="fund.short_code"
            :key="fund.id"
            :index="index + 1"
            :name="fund.short_code"
            :date="fund.data_date"
            :period="'1 Day'"
            :price="fund.nav"
            :change="fund.return_1d"
            :action="navigateToFund"
            :query="{id:fund.id}"
          ></list-item>
        </tab>
        <tab name="หุ้น" data-tab="home_trending_stock">
          <list-item
            v-for="(stock,index) in getTrendingStockList"
            data-action="open_stock"
            data-listname="trending_modal"
            :data-stockname="stock.security_name"
            :index="index + 1"
            :key="stock.security_id"
            :name="stock.security_name"
            :date="stock.data_date"
            :period="'1 Day'"
            :price="stock.close"
            :change="stock.return_1d"
            :action="navigateToStock"
            :query="{name: stock.security_name}"
          ></list-item>
        </tab>
      </tabs> -->
    </modal-slide-up>

    <div class="footer">
      <div data-action="view_all_trending" id="see-all-btn" @click="openModal()">ดูทั้งหมด</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Tab from "../../commons/Tab"
import Tabs from "../../commons/Tabs"
import ListItem from "../../commons/ListItem"
import ModalSlideUp from "../global/ModalSlideUp"

export default {
  components: {
    Tab,
    Tabs,
    ListItem,
    ModalSlideUp
  },
  data() {
    return {
      highlight: {},
      showModal: false
    }
  },
  created() {
    this.findStockTrendingList()
    this.findFundTrendingList()
  },
  computed: {
    ...mapGetters("fund", ["getTrendingFundList", "getTrendingFundTopThreeList"]),
    ...mapGetters("stock", ["getTrendingStockList", "getTrendingStockTopThreeList"])
  },
  filters: {
    date(timestamp) {
      return moment(timestamp).format("DD/MM/YY")
    }
  },
  methods: {
    ...mapActions("stock", ["findStockTrendingList", "findStockQuote"]),
    ...mapActions("fund", ["findFundTrendingList"]),
    async navigateToStock(query) {
      document.documentElement.style.overflow = null
      const hasInfo = await this.findStockQuote(query.name)
      hasInfo
        ? this.$router.push({
            name: "miniapp-stock-quote",
            query: query
          })
        : null
      // this.$router.push({ name: "miniapp-stock-quote", query: query });
    },
    navigateToFund(query) {
      document.documentElement.style.overflow = null
      this.$router.push({ name: "miniapp-fund-quote", query: query })
    },
    navigateToMarket() {
      if (decodeURIComponent(window.location.href).includes("#หุ้น")) {
        this.$router.push({ name: "miniapp-market-stock" })
      } else {
        this.$router.push({ name: "miniapp-market-fund" })
      }
    },
    openModal() {
      this.showModal = true
      this.$router.replace({
        query: { openModal: true }
      })
    },
    closeModal() {
      this.showModal = false
      let query = Object.assign({}, this.$route.query)
      delete query.openModal
      this.$router.replace({ query })
    }
  }
}
</script>

<style lang="scss" scoped>
#trending-container {
  color: $color-normal-text;

  h2 {
    margin-bottom: 8px;
    @extend %font-size-m;
  }

  #modal-header {
    font-family: DBHeaventRez;
    @extend %font-size-s;
    width: 100%;
    text-align: center;
    font-weight: bold;
  }

  .modal-item-list {
    margin: 0px;
    min-height: 824px;
    overflow: auto;
  }

  .list {
    border-radius: 4px;
    box-shadow: 0 0 4px 0 rgba(186, 186, 186, 0.24), 0 0 6px 0 rgba(228, 232, 234, 0);
    background-color: $base-white;
  }

  .footer {
    display: flex;
    justify-content: center;
    text-align: center;
    #see-all-btn {
      margin: 16px;
      font-weight: bold;
      text-align: center;
      color: $color-secondary;
      display: block;
      @extend %font-size-ss;
      border-bottom: 2px solid $color-secondary;
    }
  }
}
</style>